module.exports = __webpack_public_path__ + "img/ssl-secure.2e2c1929.png";